/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var CGF_MG_FE = {
    // All pages
    'common': {
      init: function () {

        // ****************************** GALLERY F-E ****************************** //
        var galleryThumbs = new Swiper('.gallery-thumbs', {
          spaceBetween: 10,
          slidesPerView: 6,
          loop: true,
          freeMode: true,
          loopedSlides: 5, //looped slides should be the same
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        });
        var galleryTop = new Swiper('.gallery-top', {
          spaceBetween: 10,
          loop: true,
          loopedSlides: 5, //looped slides should be the same
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: galleryThumbs,
          },
        });



        // ****************************** ORIGINAL CODE ****************************** //
        // JavaScript to be fired on all pages
        var gallery_cart = [];

        var img_thumbs = {};

        function cgf_update_cart() {
          if (typeof (sessionStorage) !== "undefined") {
            sessionStorage.setItem("cgf_cart_content", JSON.stringify(gallery_cart));
            sessionStorage.setItem("cgf_cart_thumb", JSON.stringify(img_thumbs));
          }
          cgf_update_cart_form_fields();

          $(document).find('.cgf-add-to-cart-image').each(function () {
            var id = $(this).attr('data-id');
            var btn_label = 'Add To Cart';
            var index = gallery_cart.indexOf(id);
            if (index > -1) {
              btn_label = 'Remove From Cart';
            }
            $(this).text(btn_label);
          });

        }

        function cgf_get_cart_content() {
          if (typeof (sessionStorage) !== "undefined") {
            gallery_cart = sessionStorage.getItem("cgf_cart_content");
            img_thumbs = sessionStorage.getItem("cgf_cart_thumb");
            if (!gallery_cart || typeof gallery_cart === 'undefined') {
              sessionStorage.setItem("cgf_cart_content", []);
              gallery_cart = [];
            } else {
              try {
                gallery_cart = JSON.parse(gallery_cart);
              } catch (e) {
                gallery_cart = [];
              }

            }
            if (!img_thumbs || typeof img_thumbs === 'undefined') {
              sessionStorage.setItem("cgf_cart_thumb", {});
              img_thumbs = {};
            } else {
              try {
                img_thumbs = JSON.parse(img_thumbs);
              } catch (e) {
                img_thumbs = {};
              }


            }
            cgf_update_cart_form_fields();
          }
        }

        function cgf_update_cart_form_fields() {
          $('.cgf_media_checkout_form .sic_cnt').text(gallery_cart.length);
          var form_list = $('.cgf_media_checkout_form ul');

          if (form_list.length > 0) {
            form_list.empty();
          }

          if (gallery_cart.length > 0) {
            $('#cgf_cart_content').val(gallery_cart);
            gallery_cart.forEach(function (value) {
              var img = $('.cgf-pswp-thumb[data-mediaid=' + value + ']').attr('href');
              if (img_thumbs.hasOwnProperty(value)) {
                img = img_thumbs[value];
              }
              var list_item = '<li><span class="sic-item"><span class="sic-thumb" style="background-image: url(' + img + ')"></span>CGF-' + value + '<span class="cgf-add-to-cart-image" data-id="' + value + '"></span></span></li>';
              form_list.append(list_item);
            });
            $('#cgf_image_checkout_form .sic-show').show();
            $('#cgf_cart_content-error').remove();
          } else {
            $('#cgf_cart_content').val('');
            $('#cgf_image_checkout_form .sic-show').hide().text($('#cgf_image_checkout_form .sic-show').attr('data-show'));
            $('#cgf_image_checkout_form .sic-list').hide();
            $('#cgf_image_checkout_form .selected-images-cnt').removeClass('open');
          }
        }

        cgf_get_cart_content();

        $(document).on('click', '.cgf-add-to-cart-image', function (e) {
          e.preventDefault();
          var id = $(this).attr('data-id');
          if (!gallery_cart.includes(id)) {
            gallery_cart.push(id);
            url = $('.cgf-pswp-thumb[data-mediaid=' + id + ']').attr('href');
            img_thumbs[id] = url;
            $(this).text('Remove From Cart');
          } else {
            var index = gallery_cart.indexOf(id);
            if (index > -1) {
              gallery_cart.splice(index, 1);
            }

            if (img_thumbs.hasOwnProperty(id)) {
              delete img_thumbs[id];
            }

            $(this).text('Add To Cart');
          }
          cgf_update_cart();
        });


        $(document).on('click', '.selected-images-cnt .sic-show', function (e) {

          e.preventDefault();
          var $parent = $(this).closest('.selected-images-cnt');
          console.warn($parent);
          if (!$parent.hasClass('open')) {
            $parent.addClass('open');
            $(this).text($(this).attr('data-hide'));
            $parent.find('.sic-list').slideDown(200);
          } else {
            $parent.removeClass('open');
            $(this).text($(this).attr('data-show'));
            $parent.find('.sic-list').slideUp(200);
          }
          $(".cgf-sidebar-content").stick_in_parent({
            sticky_class: 'cgf-fixed',
            offset_top: 125,
            recalc_every: 1
          });

          $(".cgf-checkout-btn").stick_in_parent({
            sticky_class: 'cgf-fixed',
            offset_top: 125,
            recalc_every: 1
          });


        });

        $(document).on('click', '.cgf-gallery-parent-cnt .cgf-checkout-btn', function (e) {
          e.preventDefault();
          $(this).closest('.cgf-gallery-parent-cnt').addClass('checkout-open');
          $('html').addClass('checkout-open');
          $('.header-wrap .hamburger').addClass('is-active');
        });

        $(document).on('click', '.cgf-sidebar-overlay', function (e) {
          e.preventDefault();
          $(this).closest('.cgf-gallery-parent-cnt').removeClass('checkout-open');
          $('html').removeClass('checkout-open');
          $('.header-wrap .hamburger').removeClass('is-active');
        });

        $(document).on('click', 'html.checkout-open .hamburger', function (e) {
          e.preventDefault();
          $('.cgf-gallery-parent-cnt').removeClass('checkout-open');
          $('html').removeClass('checkout-open');
          $('.header-wrap .hamburger').removeClass('is-active');
          $('.mega-menu-container-mobile').removeClass('.mobile-show');
        });


        $(window).load(function () {
          // MASONRY Gallery Init
          $('.cgf-gallery-grid').each(function () {
            var grid = $(this).find('.grid');
            if (grid.length > 0) {
              grid.masonry({
                // options
                columnWidth: '.grid-sizer',
                itemSelector: '.grid-item',
                percentPosition: true
              });
            }
            $(this).find('.gallery-svg-loader').slideUp();
            $(this).find('.gallery-load-cnt').addClass('loaded');

            $(".cgf-sidebar-content").stick_in_parent({
              sticky_class: 'cgf-fixed',
              offset_top: 125,
              recalc_every: 1
            });

            $(".cgf-checkout-btn").stick_in_parent({
              sticky_class: 'cgf-fixed',
              offset_top: 125,
              recalc_every: 1
            });

          });

          // Photoswipe Init
          var photoswipe_items = [];

          $('.cgf-gallery-grid').each(function () {
            var gallery_id = $(this).attr('data-galleryid');
            var $pic = $(this),
              total_img = $pic.find('.cgf-pswp-item-cnt a').length,
              getItems = function () {
                var photoswipe_items_current = [];
                $pic.find('.cgf-pswp-item-cnt a.cgf-pswp-thumb').each(function () {
                  var $href = $(this).attr('href'),
                    $size = $(this).data('size').split('x'),
                    $width = $size[0],
                    $height = $size[1],
                    $title = $(this).attr('data-ref'),
                    $media_id = $(this).attr('data-mediaid');
                  var thumbnails = '';

                  var parent = $(this);
                  if (parseInt($(this).attr('data-index')) == 1) {
                    var prev = $pic.find('.cgf-pswp-item-cnt').last().find('a');
                    var current = $(this);
                    var next = $(this).closest('.cgf-pswp-item-cnt').next().find('a');
                  }
                  if (parseInt($(this).attr('data-index')) === $pic.find('a').length) {
                    var next = $pic.find('.cgf-pswp-item-cnt').first().find('a');
                    var current = $(this);
                    var prev = $(this).closest('.cgf-pswp-item-cnt').prev().find('a');
                  }

                  if ((parseInt($(this).attr('data-index')) != 1) && (parseInt($(this).attr('data-index')) !== total_img)) {
                    var next = $(this).closest('.cgf-pswp-item-cnt').next().find('a');
                    var prev = $(this).closest('.cgf-pswp-item-cnt').prev().find('a');
                    var current = $(this);
                  }
                  var btn_label = '';

                  $title = $title + '<br /><a href="" data-id="' + $media_id + '" class="cgf-add-to-cart-image">' + btn_label + '</a>';
                  var item = {
                    src: $href,
                    w: $width,
                    h: $height,
                    title: $title
                  }
                  photoswipe_items_current.push(item);
                });
                return photoswipe_items_current;
              }
            photoswipe_items[gallery_id] = getItems();
          });
          var $pswp = $('.pswp')[0];

          var lightBox;
          $(document).on('click', '.cgf-pswp-item-cnt a.cgf-pswp-thumb', function (event) {
            event.preventDefault();
            var $pswp = $('.pswp')[0];
            var $index = parseInt($(this).attr('data-index')) - 1;
            var $large_image_container = $(this).closest('.cgf-gallery-grid');
            var $elem = $(this);
            var gallery_id = $large_image_container.attr('data-galleryid');
            var options = {
              index: $index,
              bgOpacity: 0.7,
              zoomEl: true,
              shareEl: true,
              counterEl: true,
              arrowEl: true,
              preloaderEl: true,
              showHideOpacity: true,
              maxSpreadZoom: 2,
              getThumbBoundsFn: function (index) {
                // get window scroll Y
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                // optionally get horizontal scroll
                // get position of element relative to viewport
                var rect = $elem[0].getBoundingClientRect();
                // w = width
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                // Good guide on how to get element coordinates:
                // http://javascript.info/tutorial/coordinates
              }

            }
            // Initialize PhotoSwipe
            lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, photoswipe_items[gallery_id], options);
            lightBox.init();

            lightBox.listen('initialZoomIn', function () {
              $('body').addClass('cgf-pswp-open');
              $(document).find('.cgf-add-to-cart-image').each(function () {
                var id = $(this).attr('data-id');
                var btn_label = 'Add To Cart';
                var index = gallery_cart.indexOf(id);
                if (index > -1) {
                  btn_label = 'Remove From Cart';
                }
                $(this).text(btn_label);
              });
            });

            lightBox.listen('afterChange', function () {
              $('body').addClass('cgf-pswp-open');
              $(document).find('.cgf-add-to-cart-image').each(function () {
                var id = $(this).attr('data-id');
                var btn_label = 'Add To Cart';
                var index = gallery_cart.indexOf(id);
                if (index > -1) {
                  btn_label = 'Remove From Cart';
                }
                $(this).text(btn_label);
              });

            });


            lightBox.listen('initialZoomOutEnd', function () {
              $('body').removeClass('cgf-pswp-open');
              $(document).find('.cgf-add-to-cart-image').each(function () {
                var id = $(this).attr('data-id');
                var btn_label = 'Add To Cart';
                var index = gallery_cart.indexOf(id);
                if (index > -1) {
                  btn_label = 'Remove From Cart';
                }
                $(this).text(btn_label);
              });
            });

          });

          $(document).on('click', '.pswp__caption ul li', function (e) {
            var $pswp = $('.pswp')[0];
            var $index = parseInt($(this).attr('data-index'));

            lightBox.goTo(parseInt($index) - 1);
          });
          // End of PHOTSWIPE

          $(document).find('.cgf-add-to-cart-image').each(function () {
            var id = $(this).attr('data-id');
            var btn_label = 'Add To Cart';
            var index = gallery_cart.indexOf(id);
            if (index > -1) {
              btn_label = 'Remove From Cart';
            }
            $(this).text(btn_label);
          });

        });

        function isValidEmailAddress(emailAddress) {
          var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
          return pattern.test(emailAddress);
        }

        $.validator.addMethod("supervalidemail", function (value, element) {
          // allow any non-whitespace characters as the host part
          return isValidEmailAddress(value);
        }, 'Please enter a valid email address.');

        $.validator.addMethod("noSpace", function (value, element) {
          return value === '' || value.trim().length !== 0;
        }, "No space please and don't leave it empty");

        $.validator.addMethod("validphone", function (value, element) {
          var phoneNumberPattern = new RegExp(/^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|(\([0-9]{1,5}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/);
          return phoneNumberPattern.test(value);
        }, 'Please specify a valid phone number');

        var ImageCheckoutForm = function () {
          var instance = this;
          instance.settings = {
            errorElement: 'p',
            errorPlacement: function (error, element) {
              error.appendTo(element.closest('.form-group'));
            },
            highlight: function (element, errorClass, validClass) {
              $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function (element, errorClass, validClass) {
              $(element).closest('.form-group').removeClass(errorClass).addClass(validClass);
            },
            focusInvalid: false,
            invalidHandler: function (form, validator) {
              if (!validator.numberOfInvalids())
                return;

              // $('html, body').animate({
              //   scrollTop: $(validator.errorList[0].element).offset().top - 60
              // }, 'fast');

            },

            submitHandler: function (form) {
              $theform = $(form);

              var button = $theform.find('button[type="submit"]');
              var normal_text = button.text();
              button.text(button.attr('data-loading-text')).addClass('disabled');

              var form_data = $theform.serialize();
              $.post(
                cgf_frontend_mg_scripts.ajaxurl,
                {
                  action: "cgf_submit_checkout_form",
                  formdata: form_data,
                },
                function (msg) {
                  // console.log(msg);
                  obj = JSON.parse(msg);
                  console.log(obj);

                  if (obj.success == true) {
                    gallery_cart = [];
                    img_thumbs = {};
                    cgf_update_cart();
                    $theform.parent().find('.cgf-checkout-form-error-cnt').hide();
                    $theform.find('.cgf-checkout-form-main-cnt').slideUp(function () {
                      $theform.find('.cgf-checkout-tyc-cnt').slideDown();
                    });
                  } else {
                    $theform.parent().find('.cgf-checkout-tyc-cnt').hide();
                    $theform.find('.cgf-checkout-form-main-cnt').slideUp(function () {
                      $theform.find('.cgf-checkout-form-error-cnt').slideDown();
                    });
                    $theform.find('.cgf-checkout-form-error-cnt').append('<p class="errors">' + obj.message + '</p>');
                  }
                  button.text(normal_text).removeClass('disabled');
                }
              );
              return false;
            },

            rules: {
              "cgf_checkout_name": {
                required: true,
                noSpace: true
              },
              "cgf_checkout_company": {
                required: true,
                noSpace: true
              },
              "cgf_checkout_email": {
                required: true,
                email: true,
                noSpace: true,
                supervalidemail: true
              },
              "cgf_checkout_terms": {
                required: true,
                noSpace: true
              },
              "cgf_cart_content": {
                required: true,
                noSpace: true
              },
            },
            messages: {
              "cgf_checkout_name": {
                "required": "This field is required.",
                "noSpace": "This field is required."
              },
              "cgf_checkout_company": {
                "required": "This field is required.",
                "noSpace": "This field is required."
              },
              "cgf_checkout_email": {
                "required": "This field is required.",
                "email": "Invalid e-mail address.",
                "supervalidemail": "Invalid e-mail address.",
                "noSpace": "This field is required."
              },
              "cgf_checkout_terms": {
                "required": "This field is required.",
                "noSpace": "This field is required."
              },
              "cgf_cart_content": {
                "required": "No images selected.",
                "noSpace": "No images selected."
              },
            }
          }
          instance.init = function () {
            var checkoutForm = $("#cgf_image_checkout_form");
            if (checkoutForm.length == 1) {
              checkoutForm.validate(instance.settings);
            }
          }
          instance.init();
        }
        var bfv = new ImageCheckoutForm;


      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var IO_UTIL_FE = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = CGF_MG_FE;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      IO_UTIL_FE.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        IO_UTIL_FE.fire(classnm);
        IO_UTIL_FE.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      IO_UTIL_FE.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(IO_UTIL_FE.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
